import update from 'react-addons-update'
import { CHANGE_LEVEl_1, CHANGE_LEVEl_2 } from '../actions/menuPRTRAction'

let initialState = {
  level1:'management',
  level2:'loDot',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LEVEl_1:
      return update(state, { level1: {$set: action.payload}})
    case CHANGE_LEVEl_2:
      return update(state, { level2: {$set: action.payload}})
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/@redux/reducers/menuPRTRReducer.js